import { get } from 'lodash';
export const defaultErrorMessage = 'Please try again';

function handleErrors(error) {
  const { message } = error;
  const code = get(error, 'response.data.code', error.code || null);
  const data = get(error, 'response.data', null);
  const status = get(error, 'response.status', get(error, 'status', 701));
  const errorObject = { message, code, data, status, response: error.response };
  if (process.env.NODE_ENV === 'development') {
    console.log('response::error ->', errorObject);
  }
  return Promise.reject(errorObject);
}

export default handleErrors;
